import { useState } from "react";
import { dangNhapGoogle } from "../api/auth";

// Đăng nhập Google (tái dùng pilot P0) — giao diện mới theo bộ token.
export function LoginScreen() {
  const [dangXuLy, setDangXuLy] = useState(false);
  const [loi, setLoi] = useState<string | null>(null);

  async function xuLyDangNhap() {
    setDangXuLy(true);
    setLoi(null);
    try {
      await dangNhapGoogle();
    } catch (e) {
      setLoi(e instanceof Error ? e.message : "Đăng nhập lỗi, thử lại.");
      setDangXuLy(false);
    }
  }

  return (
    <div className="cong">
      <div className="cong-the">
        <span className="brand-mark" aria-hidden>KH</span>
        <h1>KHSX — Web vận hành</h1>
        <p>Đăng nhập bằng tài khoản Google đã được cấp quyền.</p>
        <button type="button" className="btn primary" onClick={xuLyDangNhap} disabled={dangXuLy}>
          {dangXuLy ? "Đang chuyển sang Google…" : "Đăng nhập với Google"}
        </button>
        {loi && <p className="red">{loi}</p>}
      </div>
    </div>
  );
}
